// ABOUTME: Records one page_view per pathname change, named after the matched route pattern.
// ABOUTME: Also publishes the current route so explicit actions carry the same pattern and path.

import { useEffect } from 'react';
import { useLocation, useMatches } from 'react-router-dom';

import { claimPageView, enqueueAnalyticsEvent, setCurrentRoute } from '../capture/analyticsQueue';
import { buildRoutePattern } from '../capture/buildRoutePattern';

export function usePageViewTracking() {
    const { pathname } = useLocation();
    const matches = useMatches();
    const params = matches[matches.length - 1]?.params ?? {};
    const routePattern = buildRoutePattern(pathname, params);

    // Keyed on the pathname only: query-string or hash changes are not page views.
    useEffect(() => {
        setCurrentRoute({ routePattern, path: pathname });
        if (!claimPageView(pathname)) return;
        enqueueAnalyticsEvent({
            eventType: 'page_view',
            name: routePattern,
            routePattern,
            path: pathname,
            occurredAt: new Date().toISOString(),
        });
    }, [pathname, routePattern]);
}
